<template>
  <v-container class="mainContainerBackground pa-0">
    <!-- Hero Header -->
    <v-row>
      <v-col cols="12" align-content="center">
        <v-img
          alt="family having fun"
          style="width: 100%"
          src="../assets/Familyhavingfunathome.jpg"
        />
      </v-col>
      <v-col
        cols="12"
        :class="$vuetify.display.xs ? 'faster-simpler-textMob' : 'faster-simpler-text'"
      >
        <p>{{ $t('L_a_faster_simpler_path') }}</p>
      </v-col>
    </v-row>

    <!-- Pay Off Your Debt -->
    <v-row :class="$vuetify.display.xs ? 'pt-2 px-3' : 'pt-0 px-5'">
      <v-col cols="12" class="text-h2">
        {{ $t('L_pay_off_your_debt') }}
      </v-col>
      <v-col cols="12" class="text-body-1">
        {{ $t('L_excess_debt_can_be_a_threat_to_your_financial_security') }}
      </v-col>
      <v-col cols="12" class="d-flex justify-center">
        <OnexButton role="link" color="primary" class="setPlanBtnWidth" @click="goToNavigate">
          {{
            twoOrMoreDebtsAndMinOneUnpaidDebt ? $t('L_view_your_plan') : $t('L_create_your_plan')
          }}
        </OnexButton>
      </v-col>
    </v-row>

    <!-- Debt Stacking Can Help -->
    <v-row :class="$vuetify.display.xs ? 'px-3' : 'pt-0 px-5'">
      <v-col
        cols="12"
        class="text-h2"
        :class="
          $vuetify.display.xs ? 'debt_Stacking_can_help_cssMob' : 'debt_Stacking_can_help_css'
        "
      >
        {{ $t('L_debt_Stacking_can_help') }}
      </v-col>
      <v-col cols="12" class="if_the_idea_of_paying_off_your_css mt-0">
        {{ $t('L_if_the_idea_of_paying_off_your') }}
      </v-col>
      <v-col
        class="mx-4 text-body-1"
        :class="$vuetify.display.xs ? 'ml-3 mr-3 pl-3 pr-3' : 'ml-3 mr-3 pl-3 pr-3'"
      >
        <VideoPlayer
          :video-url="$t('L_debt_stacking_videoUrl')"
          :closed-caption-url="$t('L_debt_stacking_closedCaptionUrl')"
          :poster-url="$t('L_debt_stacking_posterUrl')"
        />
      </v-col>
      <v-col cols="12" class="text-body-1">
        {{ $t('L_by_taking_into_account') }}
      </v-col>
      <v-col cols="12" class="text-body-1">
        {{ $t('L_begin_by_making_consistent_payments') }}
      </v-col>
      <v-col cols="12" class="text-body-1">
        {{ $t('L_when_you_pay_off_the_target') }}
      </v-col>
      <v-col cols="12" class="text-body-1">
        {{ $t('L_debt_stacking_works_best_when') }}
      </v-col>
    </v-row>

    <!-- How Soon Could You Be Debt Free -->
    <v-row :class="$vuetify.display.xs ? 'px-3' : 'px-5'">
      <v-col cols="12" class="text-h2 mt-4">
        {{ $t('L_how_soon_could_you_be_debt_free') }}
      </v-col>
      <v-col
        cols="12"
        :class="
          $vuetify.display.xs ? 'revisit_the_my_plan_tab_cssMob' : 'revisit_the_my_plan_tab_css'
        "
      >
        {{ $t('L_revisit_the_my_plan_tab') }}
      </v-col>
    </v-row>

    <ContactRepFooter v-if="agent" />
  </v-container>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import ContactRepFooter from '@/components/ContactRep/ContactRepFooter.vue';
import { mapActions, mapState } from 'pinia';
import { useDebtSolutionsStore } from '../store/debtsolutions.store';
import { useGlobalStore } from '@/stores/global/global.store';
import { OnexButton } from '@primerica/onex-ui-lib';
import VideoPlayer from '../../../components/VideoPlayer/VideoPlayer.vue';

const componentOptions: ComponentOptions = {
  name: 'LearnMoreTab',
  components: {
    ContactRepFooter,
    OnexButton,
    VideoPlayer,
  },
  computed: {
    ...mapState(useGlobalStore, ['agents', 'getAgent']),
    ...mapState(useDebtSolutionsStore, {
      hasNoPlan: 'hasNoPlan',
      twoOrMoreDebtsAndMinOneUnpaidDebt: 'twoOrMoreDebtsAndMinOneUnpaidDebt',
      unpaidDebts: 'unpaidDebts',
      paidOffDebts: 'paidOffDebts',
    }),
    agent() {
      return this.agents?.length === 1 ? this.agents[0] : null;
    },
  },
  methods: {
    ...mapActions(useDebtSolutionsStore, {
      setAddADebtOpenFlag: 'setAddADebtOpenFlag',
    }),
    ...mapActions(useGlobalStore, {
      addError: 'addError',
    }),
    goToNavigate() {
      if (!this.twoOrMoreDebtsAndMinOneUnpaidDebt) {
        this.setAddADebtOpenFlag(true);
        this.$emit('changeTab', 0);
      } else {
        this.$emit('changeTab', 1);
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.mainContainerBackground {
  background-color: #ffffff;
}
.faster-simpler-textMob {
  margin-top: -77px;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  padding-left: 15px;
  z-index: 2;
}
.faster-simpler-text {
  margin-top: -77px;
  font-size: 26px;
  font-weight: 700;
  color: #ffffff;
  padding-left: 45px;
  z-index: 2;
}
.agentImage {
  height: 80px;
  vertical-align: middle;
}
.backgroundGray {
  background-color: #eeeeee;
}
.video {
  margin: 40px 0;
  position: relative;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
  iframe {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    position: absolute;
  }
}
.valignMiddle {
  margin: auto !important;
}
.setPlanBtnWidth {
  width: 200px;
}
.modal {
  position: fixed; /* Stay in place */
  z-index: 11; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  padding-top: env(safe-area-inset-top); /* Ensures padding below the status bar/notch */
}
.fullWidth {
  width: 100%;
}
</style>
